/**
 * Friendly labels for browser push registrations, so members can recognise and
 * remove a device in Settings, and so the native app can drop a stale browser
 * registration made on the same kind of phone.
 */

export type DevicePlatform = 'android' | 'ios' | 'macos' | 'windows' | 'other';

export const detectPlatform = (ua = navigator.userAgent): DevicePlatform => {
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  if (/mac os x/i.test(ua)) return 'macos';
  if (/windows/i.test(ua)) return 'windows';
  return 'other';
};

const platformName: Record<DevicePlatform, string> = {
  android: 'Android',
  ios: 'iPhone',
  macos: 'Mac',
  windows: 'Windows',
  other: 'this device',
};

const detectBrowser = (ua = navigator.userAgent): string => {
  if (/edg\//i.test(ua)) return 'Edge';
  if (/opr\//i.test(ua)) return 'Opera';
  if (/samsungbrowser/i.test(ua)) return 'Samsung Internet';
  if (/firefox|fxios/i.test(ua)) return 'Firefox';
  if (/chrome|crios/i.test(ua)) return 'Chrome';
  if (/safari/i.test(ua)) return 'Safari';
  return 'Browser';
};

export const detectDeviceLabel = (ua = navigator.userAgent): string =>
  `${detectBrowser(ua)} on ${platformName[detectPlatform(ua)]}`;
